import styled from 'styled-components';

export const StyledStudentPaymentsElementWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 5px;
`;
